/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from "react";
import { format } from "date-fns";
import { formatCurrency } from "../../../helpers";
import NumberCell from "../../tableFields/NumberCellNegative";

export const CALL_DETAIL_COLUMNS = [
  {
    Header: "Contract Name",
    accessor: "contract.name",
    id: "contract",
    minWidth: 250
  },
  {
    Header: "Contract Rate",
    id: "rate",
    accessor: "rate",
    Cell: ({ value }) => formatCurrency(value || 0),
    minWidth: 180
  },
  {
    Header: "Last Date Purchased",
    accessor: "purchase_date",
    Cell: ({ value }) => (value ? format(new Date(value), "MM/dd/yyyy") : "--"),
    minWidth: 180
  },
  {
    Header: "Last Hours Purchased",
    accessor: "hours_purchased",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 180
  },
  {
    Header: "Hours Balance",
    accessor: "balance",
    id: "balance",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 180
  },
  {
    Header: "Amount Balance",
    id: "amountBalance",
    accessor: "amountBalance",
    Cell: ({ value }) => (
      <NumberCell
        getValue={(val) => formatCurrency(val || 0)}
        value={value || 0}
      />
    ),
    minWidth: 180
  },
  {
    Header: "% Purchase Balance",
    accessor: "purchase_balance",
    id: "purchase_balance",
    minWidth: 100,
    Cell: ({ value }) => (
      <NumberCell
        getValue={(val) => `${val.toFixed(2)}%`}
        value={value || 0}
        threshold={20}
      />
    )
  },
  {
    Header: "Sales Person",
    accessor: "sales_person.full_name",
    id: "sales_person",
    minWidth: 250
  }
];
